/**
 * Rutas de la aplicación como constantes literales. Úselas en `to` de
 * `<Link>`/`navigate` para no repetir cadenas; TanStack Router conserva el
 * tipado porque son literales (`as const`). Para rutas con parámetros use
 * siempre la forma tipada: `{ to: '/loans/$loanId', params: { loanId } }`.
 */
export const ROUTES = {
  home: '/',
  login: '/login',
  changePassword: '/change-password',
  twoFactorSetup: '/two-factor-setup',
  simulator: '/simulador',
  dashboard: '/dashboard',
  profile: '/profile',
  clients: '/clients',
  newClient: '/clients/new',
  loans: '/loans',
  newLoan: '/loans/new',
  pipeline: '/loans/pipeline',
  payments: '/payments',
  newPayment: '/payments/new',
  cash: '/cash',
  collections: '/collections',
  field: '/field',
  compliance: '/compliance',
  reports: '/reports',
  invoices: '/billing',
  accounting: '/accounting',
  institution: '/admin/institution',
  documents: '/admin/documents',
  felSettings: '/admin/billing',
  branches: '/admin/branches',
  products: '/admin/products',
  newProduct: '/admin/products/new',
  users: '/admin/users',
  audit: '/admin/audit',
  accountingAccounts: '/admin/accounting',
} as const

/** Ruta estática registrada (sin parámetros). */
export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES]
